import { css, cx } from 'linaria';
import React from 'react';
import { filterName } from './shared/styles';
import { useListFilter } from '@jetshop/core/hooks/Filters/useListFilter';
import { ActivePlus } from './ActivePlus';
import { Checkbox } from '../../../ui/Checkbox';

export const filtersStyle = css`
  list-style: none;

  li {
    padding: 20px 40px;

    &.no-result {
      opacity: 0.5;
      pointer-events: none;
    }
  }
  li:last-of-type {
    padding: 20px 40px 40px 40px;
  }
`;

export const ListAccordion = ({ filters, accordionProps, startingIdx = 0 }) => {
  if (!filters) return null;

  const listFilters = filters.filter(
    filter => filter.__typename === 'ListFilter'
  );
  return (
    <>
      {listFilters.map((filter, idx) => (
        <ListFilter
          key={filter.id + filter.name}
          filter={filter}
          idx={idx}
          startingIdx={startingIdx}
          accordionProps={accordionProps}
        />
      ))}
    </>
  );
};

function ListFilter({ filter, idx, accordionProps, startingIdx }) {
  const { apply } = useListFilter({ filter });
  const { AccordionContent } = accordionProps;
  const accordionIsOpen = accordionProps.openIndexes.includes(
    idx + startingIdx
  );

  return (
    <>
      <div
        className={cx(filterName, 'filterwrapper')}
        onClick={() => accordionProps.handleClick(idx)}
      >
        {filter.name}
        <ActivePlus isOpen={accordionIsOpen} />
      </div>
      <AccordionContent isOpen={accordionIsOpen}>
        <ul className={filtersStyle}>
          {filter.items.map(item => {
            const resultsFound = item?.resultCount > 0;
            return (
              <li
                key={item.text + item.id}
                className={!resultsFound && 'no-result'}
              >
                <Checkbox
                  text={item.text}
                  changeCallback={() => {
                    if (resultsFound) {
                      apply({ value: item.value });
                    }
                  }}
                />
              </li>
            );
          })}
        </ul>
      </AccordionContent>
    </>
  );
}
